<template>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h1>Dashboard</h1>
  </div>
</template>

<script lang="ts" setup></script>
